import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Seo from './Seo';
import { resolvePageMeta } from '../seo/resolveMeta';

/** Applies route-aware SEO metadata on every navigation. */
export default function DocumentHead() {
  const { pathname } = useLocation();
  const meta = useMemo(() => resolvePageMeta(pathname), [pathname]);
  return <Seo {...meta} />;
}
